<!--
 * @Description:合作伙伴模块
-->

<template>
  <div :class="$style['m-partner']">
    <div class="m-container">
      <div :class="$style['container-inner']">
        <div ref="listWrapper" :class="$style['partner-list']">
          <div
            ref="listBox"
            :class="$style['list-inner']"
            class="grid grid-flow-col-dense"
          >
            <div
              v-for="(item, index) in runList"
              :key="index"
              :class="$style['partner-item']"
            >
              <div :class="$style['img-box']">
                <img :src="item.thumb" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mitt from "mitt";
// import { gsap } from "@stone/uemo-utils/utils/gsap";
// import { _debounce } from "@stone/uemo-utils/utils/lodash";
import { gsap } from "../../../utils/gsap";
import _debounce from "lodash/debounce";
import { partnerList } from "../../../data/partner";

const mittManage = mitt();

export default {
  computed: {
    runList() {
      return partnerList.concat(partnerList, partnerList, partnerList);
    }
  },

  methods: {
    createLoopAnimate() {
      const listWrapper = this.$refs.listWrapper;
      const listBox = this.$refs.listBox;
      if (!listWrapper || !listBox) return;
      const dis = listBox.scrollWidth / 4;
      const distanceDur = 4;
      const ctrl = gsap
        .timeline()
        .to(listBox, {
          duration: partnerList.length * distanceDur,
          ease: "none",
          x: () => {
            return "-=" + dis;
          }
        })
        .to(listBox, {
          duration: partnerList.length * distanceDur,
          ease: "none",
          x: () => {
            return "-=" + dis;
          },
          modifiers: {
            x: gsap.utils.unitize(x => {
              const nx = parseFloat(x);
              return (nx % dis) - dis;
            })
          },
          repeat: -1
        });
      mittManage.on("winResize", () => {
        ctrl.invalidate();
      });
      mittManage.on("destroy", () => {
        ctrl.kill();
      });
    }
  },

  mounted() {
    this.createLoopAnimate();

    const winResizeWatch = _debounce(() => {
      mittManage.emit("winResize");
    }, 200);
    mittManage.on("destroy", () => {
      $(window).off("resize", winResizeWatch);
    });

    $(window).on("resize", winResizeWatch);
  },
  beforeDestroy() {
    mittManage.emit("destroy");
    mittManage.all.clear();
  }
};
</script>
<style lang="scss" module>
@import "../../../assets/uemo-scss/scss/abstracts/_mixins.scss";
.m-partner {
  overflow: hidden;
  .container-inner {
    padding: 40px 0;
  }
  .partner-item {
    flex: 0 0 auto;

    padding: 0 35px;
  }
  .img-box {
    @include image-placeholder-v4(320, 82);
    width: 300px;

    opacity: 0.3;
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/PartnerModule.vue